/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterDeliveryOptions_viewer = {
    readonly isDeliveryOptionsDisabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterLocation_viewer">;
    readonly " $refType": "SbSharedRefineMenuFilterDeliveryOptions_viewer";
};
export type SbSharedRefineMenuFilterDeliveryOptions_viewer$data = SbSharedRefineMenuFilterDeliveryOptions_viewer;
export type SbSharedRefineMenuFilterDeliveryOptions_viewer$key = {
    readonly " $data"?: SbSharedRefineMenuFilterDeliveryOptions_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterDeliveryOptions_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterDeliveryOptions_viewer",
  "selections": [
    {
      "alias": "isDeliveryOptionsDisabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "DISABLE_SB_DELIVERY_OPTION_FILTERS"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"DISABLE_SB_DELIVERY_OPTION_FILTERS\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterLocation_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'af10361da2bdf1860303d8bbf5dcb928';
export default node;
